import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/internal/operators/tap';
import { InterceptorSkipHeader } from '@models/headers/interceptor-skip-header';
import { AppConfig } from '@models/appconfig';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class AppConfigProvider {
  public environment: ReplaySubject<AppConfig> = new ReplaySubject(1);

  constructor(private http: HttpBackend) {}

  load() {
    const headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    const httpClient = new HttpClient(this.http);

    return httpClient
      .get('../config.json', { headers })
      .pipe(
        tap((configFile: AppConfig) => {
          this.environment.next(configFile);
        })
      )
      .toPromise();
  }
}
